/**  */
const INVENTORY = {
    RECONDITIONING_TYPES: [
        'auction',
        'labor only', 
        'parts only', 
        'parts & labor', 
        'paint & body',
        'transportation'
    ],
    ODOMETER_TYPES: [
        { value: 'actual', name: 'Actual Mileage' },
        { value: 'not_actual', name: 'Not Actual Mileage (WARNING - ODOMETER DISCREPANCY)' },
        { value: 'exceeds', name: 'Exceeds Mechanical Limits' },
        { value: 'exempt', name: 'Exempt' }
    ],
    TITLE_CONDITIONS: [
        { value: 'regular', name: 'Regular' },
        { value: 'rebuiltSalvage', name: 'Rebuilt Salvage' },
        { value: 'salvage', name: 'Salvage' },
        { value: 'floodDamage', name: 'Flood Damaged' },
        { value: 'insuranceCompany', name: 'Insurance Company' },
        { value: 'inoperable', name: 'Inoperable Airbag' },
        { value: 'mso', name: 'MSO-New Vehicle' },
        { value: 'demonstrator', name: 'Demonstrator' },
        { value: 'factory', name: 'Factory Official or Executive' },
        { value: 'nonrepairable', name: 'Nonrepairable' }
    ],
    VEHICLE_TYPES: [
        { name: 'ATV' },
        { name: 'Boat' },
        { name: 'Bus' },
        { name: 'Car' },
        { name: 'Farm Trailer' },
        { name: 'Farm Truck' },
        { name: 'Farm Tractor' },
        { name: 'Moped' },
        { name: 'Motorcycle' },
        { name: 'Motorhome' },
        { name: 'Motorscooter' },
        { name: 'Pickup' },
        { name: 'SUV' },
        { name: 'Tractor' },
        { name: 'Trailer' },
        { name: 'Travel Trailer' },
        { name: 'Truck' },
        { name: 'Van' }
    ],
    COLORS: [
        { id: 1, name: 'Black', code: 'BLK' },
        { id: 2, name: 'Blue', code: 'BLU' },
        { id: 3, name: 'Brown', code: 'BRO' },
        { id: 4, name: 'Camouflage', code: '' },
        { id: 5, name: 'Gold', code: 'GLD' },
        { id: 6, name: 'Gray', code: 'GRY' },
        { id: 7, name: 'Green', code: 'GRN' },
        { id: 8, name: 'Maroon', code: 'MAR' },
        { id: 9, name: 'Orange', code: 'ONG' },
        { id: 10, name: 'Pink', code: 'PNK' },
        { id: 11, name: 'Purple', code: 'PLE' },
        { id: 12, name: 'Red', code: 'RED' },
        { id: 13, name: 'Silver', code: 'SIL' },
        { id: 14, name: 'Tan', code: 'TAN' },
        { id: 15, name: 'White', code: 'WHI' },
        { id: 16, name: 'Yellow', code: 'YEL' },
    ],
    CERTIFY_LEVELS: [
        { code: 'v', description: 'VIN Verified' },
        { code: 'u', description: 'VIN Unverified. Vehicle Unrecovered Stolen' },
        { code: 'tld', description: 'Title Lost or Destroyed' },
    ],
    AIRBAG_STATUSES: [
        { value: 'deployed', name: 'Deployed' },
        { value: 'intact', name: 'Not Deployed' },
        { value: 'unknown', name: 'History Unknown' }
    ]
};


module.exports = {
    INVENTORY
};
